import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Globals {
    public __SCREEN_HEIGHT = window.innerWidth;
}